import { GetterTree } from "vuex";
import { StoreState } from "@/store/type";
import {
  GroupedFlightsMap,
  IQuotationManagementState,
  SurchargesPayload,
  UpdatedFareOptions,
  SurchargeDataItem,
  SurchargeDataWithAirlineCode,
} from "@/core/interfaces/state/quotationManagmentState.interface";

const getters: GetterTree<IQuotationManagementState, StoreState> = {
  groupedQuotesByAirlineMap: (state): GroupedFlightsMap | null =>
    state.groupedQuotesByAirlineMap,

  getSurchargeByAirline: (state) => (airlineCode: string) => {
    return state.surcharges.find((s) => s.airlineCode === airlineCode);
  },

  allSurcharges: (state) => {
    return state.surcharges;
  },

  surchargesPayload: (state: {
    surcharges: SurchargeDataWithAirlineCode[];
  }): SurchargesPayload => {
    const groupsWithValidTokens = state.surcharges.filter((group) =>
      group.data.some(
        (item: SurchargeDataItem) => item.pre_booking_tokens.length > 0,
      ),
    );

    const allValidItems = groupsWithValidTokens.flatMap((group) =>
      group.data.filter(
        (item: SurchargeDataItem) => item.pre_booking_tokens.length > 0,
      ),
    );

    return {
      data: allValidItems,
    };
  },

  isApplySurchargePending: (state): boolean => state.isApplySurchargePending,
  isClearAllSurchargesPending: (state): boolean =>
    state.isClearAllSurchargesPending,

  quotationRenderTrigger: (state): boolean => state.quotationRenderTrigger,

  updatedFareOptions: (state): UpdatedFareOptions | null =>
    state.updatedFareOptions,
};

export default getters;
